export default __webpack_public_path__ + "static/media/grafema_pilates_05.5aad0436.jpg";